var exports = {
  "R": "desktopInstructionsText__0WhRwq",
};

module.exports = exports;
